/* Printies Junk Food clicker picker. Tier selection, per-clicker food/face,
   live button price, accordion summary lines and the mobile sticky bar.
   No paid extras — the form posts natively to /cart/add. */
(function () {
  var root = document.getElementById("pt-clk");
  var form = document.getElementById("pt-clk-form");
  if (!root || !form) return;

  var bars = root.querySelectorAll(".pt-clk__bar");
  var units = root.querySelectorAll(".pt-clk__unit");
  var btn = root.querySelector(".pt-clk__btn");
  var out = document.getElementById("pt-clk-btnprice");
  var sticky = document.getElementById("pt-clk-sticky");
  var stickyPrice = document.getElementById("pt-clk-stickyprice");
  var stickyBtn = document.getElementById("pt-clk-stickybtn");

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function refreshPrice() {
    var sel = root.querySelector(".pt-clk__input:checked");
    if (!sel) return;
    var total = parseInt(sel.dataset.cents, 10) || 0;
    if (out) out.textContent = money(total);
    if (stickyPrice) stickyPrice.textContent = money(total);
  }

  function refreshSummary(i) {
    var el = document.getElementById("pt-clk-sum" + i);
    if (!el) return;
    var parts = [];
    var food = root.querySelector('input[data-role="food"][data-unit="' + i + '"]:checked');
    var face = root.querySelector('input[data-role="face"][data-unit="' + i + '"]:checked');
    if (food) parts.push(food.dataset.name);
    if (face) parts.push(face.value === "Classic" ? "Classic" : "Smiley");
    el.textContent = parts.join(" · ");
  }

  function activate(bar) {
    var count = parseInt(bar.getAttribute("data-units"), 10) || 1;
    bars.forEach(function (b) {
      var on = b === bar;
      b.classList.toggle("is-on", on);
      if (on) b.querySelector(".pt-clk__input").checked = true;
    });
    units.forEach(function (u) {
      var show = (parseInt(u.getAttribute("data-unit"), 10) || 1) <= count;
      u.hidden = !show;
      u.querySelectorAll("input").forEach(function (input) { input.disabled = !show; });
    });
    refreshPrice();
  }

  bars.forEach(function (b) {
    b.querySelector(".pt-clk__input").addEventListener("change", function () { activate(b); });
  });

  root.querySelectorAll('input[data-role="food"]').forEach(function (input) {
    input.addEventListener("change", function () {
      var label = document.getElementById("pt-clk-c" + input.dataset.unit);
      if (label) label.textContent = input.dataset.name;
      refreshSummary(input.dataset.unit);
    });
  });

  root.querySelectorAll('input[data-role="face"]').forEach(function (input) {
    input.addEventListener("change", function () { refreshSummary(input.dataset.unit); });
  });

  if (sticky && stickyBtn && btn && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      sticky.hidden = entries[0].isIntersecting;
    });
    io.observe(btn);
    stickyBtn.addEventListener("click", function () {
      if (form.requestSubmit) form.requestSubmit();
      else btn.click();
    });
  }

  var checked = root.querySelector(".pt-clk__input:checked") || root.querySelector(".pt-clk__input");
  if (checked) activate(checked.closest(".pt-clk__bar"));
  units.forEach(function (u) { refreshSummary(u.getAttribute("data-unit")); });
})();
